import { Flex } from "@mantine/core";
import { ErrorBoundary } from "react-error-boundary";

import type { ExpertUniversitySimulatedVoiceTask } from "@/expert-university";

import { CustomerPanelWrapper } from "@/customer-panel/CustomerPanelWrapper";
import { MockCustomerPanel } from "@/customer-panel/mock-customer-panel/MockCustomerPanel";
import { RenderError } from "@/shared-utils";

interface WorkspaceContentRightSidebarSlotProps {
    activeExpertUniversityTask: ExpertUniversitySimulatedVoiceTask | null;
    customerSession: boolean;
    customerPanelEnabled: boolean;
    isRealCustomerPanelEnabledForTraining: boolean | undefined;
}

export function WorkspaceContentRightSidebarSlot({
    isRealCustomerPanelEnabledForTraining,
    customerSession,
    customerPanelEnabled,
    activeExpertUniversityTask,
}: WorkspaceContentRightSidebarSlotProps) {
    if ((!customerSession || !customerPanelEnabled) && !activeExpertUniversityTask) {
        return null;
    }

    return (
        <Flex pos={"absolute"} inset={0}>
            <ErrorBoundary fallback={<RenderError />}>
                {activeExpertUniversityTask && !isRealCustomerPanelEnabledForTraining ? (
                    <MockCustomerPanel />
                ) : (
                    <CustomerPanelWrapper />
                )}
            </ErrorBoundary>
        </Flex>
    );
}
